export default () => ({
    visible: false,
    onScroll() {
        this.visible = window.scrollY > window.innerHeight;
    },
    onClick() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },
    init() {
        this.onScroll();
        addEventListener('scroll', this.onScroll.bind(this));
    }
});